import { render, staticRenderFns } from "./MentionsByDaypart.vue?vue&type=template&id=c37661d6"
import script from "./MentionsByDaypart.vue?vue&type=script&lang=js"
export * from "./MentionsByDaypart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports